const SHIFT = [
    { value: "Morning", label: "Matutino" },
    { value: "Afternoon", label: "Vespertino" },
    { value: "Evening", label: "Noturno" },
    { value: "FullTime", label: "Integral" },
];

export default SHIFT